import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { envAwarePost } from '../../../util/util'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import { useHistory } from 'react-router-dom'
import { selectTrainerParam } from '../../users/usersSlice'
import Spinner from 'react-bootstrap/Spinner'
import Card from 'react-bootstrap/Card'
import { useEvent } from '../../../hooks/events'
import EventDetails from "../../EventDetails/EventDetails"
import Form from 'react-bootstrap/Form'
import { capitalize, extractEventParams } from '../../../util/util'
import {
	getFavoriteDetails,

} from "../../../state/events";
import moment from 'moment'
import {
	updateEvent,
	addItemToEvent,
	getEventDetails,
	applyAdditionalOptions,
	toggleWorkoutCompactMode
} from '../../../state/events'

const Templates = ({ show, setShow, client_id, eventType }) => {
	let history = useHistory();
	const trainerParam = useSelector(selectTrainerParam)
	const [templates, setTemplates] = useState([])
	const [isLoading, setIsLoading] = useState(0)
	const [filteredTemplates, setFilteredTemplates] = useState([]);
	const [searchQuery, setSearchQuery] = useState("");
	const [isLoadingTemplates, setIsLoadingTemplates] = useState(false)
	const userId = useSelector(state => state.users.current_user.user_id_number);
	const [showDetails, setShowDetails] = useState([])
	const [isDetailsLoading, setIsDetailsLoading] = useState("");
	const event = useSelector((state) => state.allEvents.favoriteEventDetails)

	const dispatch = useDispatch();

	useEffect(() => {
		if (show) {
			setIsLoadingTemplates(true)
			envAwarePost("api/events/api/", {
				action: 'getEventTemplates',
				event_type: eventType
			}).then(res => {
				setTemplates(res.data.events)
				setIsLoadingTemplates(false)
			})
		}
	}, [show])
	/**
	 * Sends request to api to copy template to target account 
	 * Then redirects to editor
	 */
	const handleAdd = (event_id) => {
		let id = client_id
		if (!client_id) {
			id = userId
		}
		let todaysDate = moment(new Date()).format("YYYY-MM-DD")
		envAwarePost('api/events/api/', {
			action: 'copyAndEdit',
			//favorites should be added to the logged in user's account
			//so send this id
			tgt_client_id: client_id==='favorite'?userId:id,
			event_type: eventType,
			event_id,
			start_date: todaysDate,
			end_date: todaysDate
		}).then(res => {
			let eventID = eventType === "nutrition" ? res.data.nutrition_id :
				eventType === "task" ? res.data.task_id
					: res.data.workout_id
			setIsLoading(0)

			//window.location = `/addEvent/?client=${client_id}&event_id=${res.data.workout_id}&selector=AddOrEdit&eventType=Workout`
			if (!client_id) {
				history.push(`/eventEditor/?event_id=${eventID}&event_type=AddOrEdit&eventType=${eventType}&client=favorite${selectTrainerParam && `&${trainerParam}`}`)
			} else {
				history.push(`/eventEditor/?event_id=${eventID}&event_type=AddOrEdit&eventType=${eventType}&client=${id}${selectTrainerParam && `&${trainerParam}`}`)
			}

		})
	}

	useEffect(() => {
		if (searchQuery) {
			let cleanedQuery = searchQuery.toLowerCase().trim();
			let filtered = templates.filter(item => {
				return item.note.toLowerCase().includes(cleanedQuery);
			})
			setFilteredTemplates(filtered);
		} else {
			setFilteredTemplates(templates);
		}
	}, [templates, searchQuery])

	// show workout details
	const handleShowDetails = (eventId) => {

		const payload = {
			clientID: "99999999",
			eventID: eventId,
			eventType: "workout"
		}

		// close showDetails if already open
		if (eventId == showDetails) {
			setShowDetails("")
			return;
		} 
		// get event details
		setIsDetailsLoading(eventId)
		dispatch(getFavoriteDetails(payload)).then(
			res => {
				setShowDetails(eventId)
				setIsDetailsLoading("")
			}
		)


	}

	console.log(client_id)

	return (
		<Modal size="lg" show={show} onHide={() => { setShow(false) }}>
			<Modal.Header closeButton>
				<Modal.Title>Templates</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form.Control placeholder={`Search ${capitalize(eventType)} Templates`} value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
				<Table>
					<thead>
						<tr>
							<th>{capitalize(eventType)}</th>
							<th className="text-right" ><span className="pr-2"> Add</span></th>
						</tr>
					</thead>
					<tbody>
						{isLoadingTemplates ? <Spinner className="mt-2" animation="border" variant="primary" /> :

							filteredTemplates?.length > 0 ?
								filteredTemplates?.map(template => {
									return (
										<tr key={template[eventType + "_id"]}>
											<td><a href="#" onClick={() => { handleShowDetails(template[eventType + "_id"]) }}> {template.note}</a>
												{
													(showDetails == template[eventType + "_id"]) && isDetailsLoading != template[eventType + "_id"]? (
														<EventDetails 
															key={template[eventType + "_id"] + "det"}
															event={event}
															eventType={eventType}
															/>
													) :
														<span> {isDetailsLoading == template[eventType + "_id"]&& <Spinner size="sm" animation="border" role="status" variant="primary" ></Spinner>}</span>

												}
											</td>
											<td className="text-right">
												<Button
													onClick={() => { handleAdd(template.event_id); setIsLoading(template.event_id) }}
													size="sm"
													variant="success"
													style={{ width: '43px' }}
												>
													{template.event_id === isLoading ?
														<Spinner animation="border" role="status" style={{ width: '20px', height: '20px' }} />
														:
														'Add'
													}
												</Button>

											</td>
										</tr>

									)
								}) : <div className="mt-2"> No Templates Avaliable</div>}
					</tbody>
				</Table>
			</Modal.Body>
		</Modal>
	)
}

export default Templates